class ScrollTo {
	constructor() {
		this.initialize();
	}

	initialize() {
		$(document).ready(function() {
			if (window.location.hash) {
				let anchor = window.location.hash;
				let scrollNode = $('[id="' + anchor + '"]');

				if (scrollNode.length) {
					$('html, body').animate(
						{
							scrollTop: (scrollNode.offset().top - 20),
						},
						500
					);
				}
			}
		});
	}
}

new ScrollTo();
